var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpEngineer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7857 0.5H12.2178C11.6309 0.500748 11.0565 0.678412 10.572 1.0098C10.0881 1.34078 9.71506 1.80974 9.50142 2.35564L8.7844 4.17016L6.5954 5.43738L4.66706 5.14334C4.08588 5.05564 3.49176 5.14528 2.96234 5.40054C2.43314 5.6557 1.99278 6.06516 1.69948 6.57418L0.918072 7.92648C0.624004 8.43536 0.490274 9.02114 0.534352 9.60724C0.578418 10.1932 0.798474 10.7526 1.16516 11.2117L2.38392 12.7388V15.2612L1.16482 16.7887C0.798138 17.2478 0.578418 17.8068 0.534352 18.3928C0.490274 18.9789 0.624014 19.5646 0.918082 20.0736L1.70022 21.4272C1.99352 21.9358 2.43334 22.3444 2.96234 22.5994C3.49176 22.8548 4.08704 22.9442 4.66822 22.8564L6.60104 22.5626L8.7838 23.8226L9.49712 25.6424C9.71064 26.1892 10.084 26.6588 10.5684 26.9902C11.0529 27.3216 11.6273 27.4992 12.2143 27.5H13.7798C14.3668 27.4992 14.9399 27.3216 15.4244 26.9902C15.9086 26.659 16.2822 26.1886 16.4958 25.6422L17.209 23.8226L19.3918 22.5626L21.3258 22.8566C21.907 22.9444 22.501 22.8548 23.0304 22.5994C23.5594 22.3444 24 21.9346 24.2934 21.4258L25.0748 20.0736C25.3688 19.5646 25.5026 18.9789 25.4584 18.3928C25.4144 17.8071 25.194 17.2473 24.8276 16.7883L23.616 15.262V12.7388L24.8348 11.2117C25.2016 10.7525 25.4216 10.1933 25.4656 9.60722C25.5096 9.02112 25.376 8.43536 25.0818 7.92646L24.3 6.5732C24.0066 6.06432 23.5668 5.65566 23.0376 5.40054C22.5082 5.14528 21.913 5.05582 21.3318 5.14352L19.399 5.4375L17.2195 4.17928L16.5024 2.35634C16.2888 1.81014 15.9157 1.34092 15.4316 1.0098C14.9471 0.678412 14.3727 0.50075 13.7857 0.5ZM13 19.7551C15.7492 19.7551 18.0482 17.8274 18.619 15.25H13.518L9.91116 18.8568C10.8036 19.4256 11.8633 19.7551 13 19.7551ZM8.14334 17.0891L11.5124 13.7201L9.59804 9.35752C8.17114 10.4049 7.24488 12.0943 7.24488 14C7.24488 15.1368 7.57448 16.1966 8.14334 17.0891ZM11.8871 8.3524L13.8168 12.75H18.619C18.0482 10.1726 15.7492 8.24488 13 8.24488C12.6193 8.24488 12.2472 8.28184 11.8871 8.3524Z",
    fill: "url(#paint0_linear_3_187)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_187",
    x1: 4.8204,
    y1: 16.8052,
    x2: 25.3178,
    y2: 17.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3965FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#0071F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#0096F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E6F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpEngineer);
export default __webpack_public_path__ + "static/media/exp-engineer.0e4797d157e020ab8b020f46f619aee9.svg";
export { ForwardRef as ReactComponent };